import { getFeatures } from '@apis';
import { useQuery } from '@tanstack/react-query';

const useGetFeatures = () => {
  return useQuery({
    queryFn: () => getFeatures(),
    queryKey: ['features'],
    select: (response) => response.data.result,
  });
};

export default useGetFeatures;
